<template>
    <div class="pictures">
        <servicesList></servicesList>
        <ul>
            <li v-for="(n,i) in imgLists" :key="i"><img :src="weburl+ n.img" alt=""></li>
        </ul>
    </div>
</template>

<script>
    import servicesList from '../../components/services/servicesList';

    export default {
        name: "pictures",
        components: {
            servicesList
        },
        data(){
           return{
               imgLists: []
           }
        },
        created: function () {
            this.getPicturesInfo();
            this.$store.commit("set_current_index", 7);
            this.$store.commit("set_current", 5);
            this.$store.commit("set_title", 'nav.service');
        },
        methods: {
            getPicturesInfo: function () {
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + "/home/serve/getImage ",
                    dataType: "json",
                    data:{
                        lang: window.$lang
                    }
                })
                    .then(res => {
                        if (res.data.status === 1) {
                            this.imgLists = res.data.result;
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        },
        computed: {
            //计算属性，
            weburl: function () {
                return this.$store.state.weburl;
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/less/common.less";

    .pictures {
        width: @width;
        background: @bg;
        ul {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            .box-sizing;
            padding: 20px;
            li {
                width: 46.8%;
                height: 120px;
                .border(3px; solid; @font-primary);
                .box-sizing;
                margin: 0 20px 20px 0;
                @media (max-width: 320px) {
                    margin: 0 10px 20px 0;
                    height: 86px;
                }
                &:nth-child(2n) {
                    margin-right: 0 !important;
                }
                img {
                    .img
                }
            }
        }
    }

    @media (min-width: 768px) and (orientation: portrait) {
        .pictures {
            ul {
                li {
                    width: 31.5%;
                    height: 155px;
                    &:nth-child(2n) {
                        margin-right:20px !important;
                    }
                    &:nth-child(3n) {
                        margin-right:0 !important;
                    }
                }
            }
        }
    }

</style>
